import * as React from "react";

function SvgNext(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" fill="none" {...props}>
      <path d="M11 24l10-8-10-8v16z" fill="#fff" />
    </svg>
  );
}

export default SvgNext;
